import $api from "../api";
// import Swal from "sweetalert2";

export const state = {
    data: {
        list: [],
        links: [],
        current_page: 0,
        last_page: 0,
        per_page: 0,
        total: 0,
    },
};

export const actions = {
    getSummaryStatList({ rootGetters }, pl) {
        return new Promise(function (resolve) {
            $api
                .get(`summary/statistics?` + new URLSearchParams(pl).toString(), {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                })
                .then(function (res) {
                    if (res.status == 200) resolve(res.data.data);
                })
                .catch(function (err) {
                    if (!err.response) { resolve(null); return; }
                });
        });
    },
    getChapterList({ rootGetters }, pl) {
        return new Promise(function (resolve) {
            $api
                .get(`summary/chapters?` + new URLSearchParams(pl).toString(), {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                })
                .then(function (res) {
                    if (res.status == 200) resolve(res.data.data);
                    else resolve(null);
                })
                .catch(function () {
                    resolve(null);
                });
        });
    },
    getFarmAddressList({ rootGetters }, pl) {
        return new Promise(function (resolve) {
            $api
                .get(`summary/farms?` + new URLSearchParams(pl).toString(), {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                })
                .then(function (res) {
                    if (res.status == 200) resolve(res.data.data);
                    else resolve(null);
                })
                .catch(function () {
                    resolve(null);
                });
        });
    },
    getStagRegistryList({ rootGetters }, pl) {
        return new Promise(function (resolve) {
            $api
                .get(`summary/stags?` + new URLSearchParams(pl).toString(), {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                })
                .then(function (res) {
                    if (res.status == 200) resolve(res.data.data);
                    else resolve(null);
                })
                .catch(function () {
                    resolve(null);
                });
        });
    },
    getBreederList({ rootGetters }, pl) {
        return new Promise(function (resolve) {
            $api
                .get(`summary/breeders?` + new URLSearchParams(pl).toString(), {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                })
                .then(function (res) {
                    if (res.status == 200) resolve(res.data.data);
                    else resolve(null);
                })
                .catch(function () {
                    resolve(null);
                });
        });
    },
    getStatistics({ rootGetters }, pl) {
        return new Promise(function (resolve) {
            $api
                .get(`${window.location.origin}/json/summary-statistics.json?` + new URLSearchParams(pl).toString(), {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                })
                .then(function (res) {
                    if (res.status == 200) resolve(res.data.data);
                })
                .catch(function (err) {
                    if (!err.response) { resolve(null); return; }
                });
        });
    },
    downloadSummary({ rootGetters }, pl) {
        return new Promise(function (resolve) {
            $api
                .post("stag/export-stag-summary", pl, {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                    responseType: 'blob',
                })
                .then(function (res) {
                    if (res.status == 200) {
                        const url = window.URL.createObjectURL(new Blob([res.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Summary.csv');
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }
                })
                .catch(function (err) {
                    if (!err.response) { resolve(null); return; }
                    if (err.response.status == 422) resolve(err.response.data);
                    else resolve(err.response.data);
                });
        });
    },
};

export const mutations = {
    setData(state, data) {
        state.data.list = data.data;
        state.data.links = data.links;
        state.data.current_page = data.current_page;
        state.data.last_page = data.last_page;
        state.data.per_page = data.per_page;
        state.data.total = data.total;
    },
    clearData(state) {
        state.data.list = [];
        state.data.links = [];
        state.data.current_page = 0;
        state.data.last_page = 0;
        state.data.per_page = 0;
        state.data.total = 0;
    },
};

export const getters = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
